var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandwidthSites({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_739_16744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6522 10.8257L23.2174 28.9996C22.4783 30.8692 21.1739 31.9561 19.7391 31.9561C18.5652 31.9561 17.5652 31.3474 17 30.3909C16.3913 29.2605 16.4348 27.8692 17.1739 26.6953L28.2174 8.99961C28.7826 8.13005 29.913 7.8257 30.8261 8.30396C31.7391 8.78222 32.087 9.86918 31.6522 10.8257ZM34.6087 16.0866C33.9565 15.3909 32.8696 15.3474 32.1304 15.9996C31.4348 16.6518 31.3913 17.7387 32.0435 18.4779C34.913 21.6083 36.5217 25.6953 36.5217 29.9996C36.5217 30.9561 37.3044 31.7387 38.2609 31.7387C39.2174 31.7387 40 30.9561 40 29.9996C40 24.8257 38.087 19.8692 34.6087 16.0866ZM21.3913 13.217C22.3478 13.304 23.1739 12.6083 23.2609 11.6518C23.3478 10.6953 22.6522 9.86918 21.6957 9.78222C21.1304 9.73874 20.5652 9.69527 20 9.69527C8.95652 9.69527 0 18.8257 0 30.0431C0 30.9996 0.782609 31.7822 1.73913 31.7822C2.69565 31.7822 3.47826 30.9996 3.47826 30.0431C3.47826 20.7387 10.8696 13.1735 20 13.1735C20.4783 13.13 20.9565 13.1735 21.3913 13.217Z",
    fill: "#135FC2",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_739_16744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandwidthSites);
export default __webpack_public_path__ + "static/media/BandwidthSites.9038b5d3ac267b94de3e425e0a5d957c.svg";
export { ForwardRef as ReactComponent };